<ng-container [formGroup]="form">
  <ng-container formArrayName="locations">
    <ng-container *ngFor="let languageForm of locationsFormArray.controls; let index = index">
      <div nz-row [formGroupName]="index">
        <div nz-col [nzSpan]="23">
          <mh-location-input formControlName="location" [distanceInput]="true"></mh-location-input>
        </div>
        <div nz-col [nzSpan]="1">
          <button *ngIf="index > 0 && !disabled" nz-button [nzType]="'link'" (click)="deleteLocationOption(index)">
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>
          <button *ngIf="index == 0 && !disabled" nz-button [nzType]="'link'" (click)="addLocationOption()">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
